// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelCreateParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
  InputFile,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import ErrorLog from '@vroskus/library-sentry/dist/browser';
import {
  getRegionSeasonDateRange,
} from '../../../helpers';
import config from '../../../config';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $ModelCreateParams<'Regatta'>;
  referenceData: Array<$Model<'Regatta'>>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegattaMinimalFieldsView = function ({
  item,
  main,
  referenceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <InputDateTime
            label={t('Start date')}
            labelOpenCalendar={t('Open calendar')}
            name={'StartDate'}
            range={getRegionSeasonDateRange({
              main,
            })}
            required
            timezone={main.timezone}
            value={item.StartDate}
          />
        </Col>
        <Col sm={6}>
          <InputDateTime
            label={t('End date')}
            labelOpenCalendar={t('Open calendar')}
            name={'EndDate'}
            range={getRegionSeasonDateRange({
              main,
            })}
            required
            timezone={main.timezone}
            value={item.EndDate}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Location')}
            name={'Location'}
            required
            value={item.Location}
          />
        </Col>
        <Col>
          <InputFile
            fileDirUrl={`${config.CDN_URL}/images/max`}
            imageThumbDirUrl={`${config.CDN_URL}/images/min`}
            label={t('Logo')}
            labelChangeFile={t('Change file')}
            labelError={t('Error')}
            labelFile={t('File')}
            name={'Image'}
            onError={ErrorLog.exception}
            uploadUrl={`${config.CDN_URL}/v1.0/upload/image`}
            value={item.Image}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Last year regatta')}
            name={'ReferenceId'}
            type={'select'}
            value={item.ReferenceId}
          >
            <option />
            {_.map(
              referenceData,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default RegattaMinimalFieldsView;
